import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from '../styles'
import AccordionSummaryContent from '../accordion-summary-content'

const EveryoneAccess = props => {
  const { accessRule, handleAccessRule, classes } = props

  return (
    <AccordionSummaryContent
      accessRule={accessRule}
      handleClickSwitch={() => handleAccessRule(0)}
      contentHeader="Public"
      contentDescription="Anyone with the link can access"
      accessRuleEqual={0}
    />
  )
}

export default withStyles(styles)(EveryoneAccess)
